export declare type SBMsgBusTopics = {
    [key: string]: Function[]
}

export declare type SBMsgBusMessage = {
    [key: string]: any
}

export declare type SBMsgBus = {
    sbPrefix: "sb_"
    isActive: boolean
    type: "parent" | "child"
    topics: SBMsgBusTopics
    post(m: SBMsgBusMessage): void
    subscribe(t: string, c: Function): void
    unsubscribe(t: string, c: Function): void
}

(function () {

    // meet the true enemy ... browser support :D
    let passiveEvent: any = false;
    try {
        var opts = Object.defineProperty({}, "passive", {
            get() {
                passiveEvent = true;
            }
        });
        window.addEventListener("test", () => { }, opts);
    } catch (e) { }

    passiveEvent = passiveEvent ? { capture: true, passive: true } : true;

    function sbFindIframeContentWindow(s: string): Window | undefined {
        let iframe;
        let f: NodeListOf<HTMLIFrameElement> = document.getElementsByTagName("iframe");
        iframe = Array.prototype.filter.call(f, x => x.src.match(s))[0];
        linkedFrames.push(iframe);
        let contentWindow = iframe && iframe.contentWindow;
        return contentWindow;
    }

    function sbRemoveFromList(list: any[], item: any) {
        let i = list.indexOf(item);
        i > -1 && list.splice(i, 1);
    }

    function cacheMaintainer(t: string, m: any) { messagesCache[t] = m; }

    function garbageColletor() {
        if (window["sbMsgBus"]) {
            let b: SBMsgBus = window["sbMsgBus"];
            Object.keys(b.topics).forEach(x => {
                if (b.topics[x].length === 0) {
                    delete b.topics[x];
                    delete messagesCache[x];
                }
            });
        }
    }

    function initGC() {
        garbageColletor();
        setTimeout(initGC, 10000);
    }
    setTimeout(initGC, 10000);

    const messagesCache: any = {};

    // nulled on deactivate - needs to be VAR
    var linkedFrames: HTMLIFrameElement[] = [];
    var linkedWindows: Window[] = [];

    const internalPrefix: string = "sb-mbus-";
    const sbPrefix: string = "sb_";

    // !!! IMPORTANT
    // -> window.opener is not consistent between web browsers!

    /**
     * SBMsgBus
     * Establishes a way for our application to communicate between iframes and windows created by window.open(...)
     */
    class SBMsgBus {
        type: string
        sbPrefix: string
        isActive: boolean
        topics: SBMsgBusTopics

        constructor() {
            this.sbPrefix = sbPrefix;
            this.type = "";
            this.isActive = false;
            this.topics = Object.create(null);
            this.receiveMessages = this.receiveMessages.bind(this);
            this.deactivate = this.deactivate.bind(this);
            this.activate();
        }

        activate() {
            this.isActive = true;
            this.type = "parent";
            if ((window.opener !== null && window.opener !== undefined) || window.parent !== window) {
                this.initAsChild();
            }
            window.addEventListener("onunload", this.deactivate, true);
            window.addEventListener("message", this.receiveMessages, true);
            this.link(window);
            return this;
        }

        deactivate() {
            this.isActive = false;
            this.topics = Object.create(null);
            this.post({ "sb-mbus-unlink": window.location.toString() });
            linkedFrames = [];
            linkedWindows = [];
            window.removeEventListener("onunload", this.deactivate, true);
            window.removeEventListener("message", this.receiveMessages, true);
            this.unlink(window); // unlink self for messages
            return this;
        }

        private initAsChild() {
            this.type = "child";
            this.link((window.opener === null || window.opener === undefined) ? window.parent : window.opener);
            this.post({ "sb-mbus-link": window.location.origin.toString() });
            return this;
        }

        link(s: string | Window) {
            if (!this.isActive) { return this; }

            let sibling;

            if (typeof s === "string") {
                sibling = sbFindIframeContentWindow(s);
            }

            //For some reason in IE postMessage is object
            if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
                sibling = s;
            }

            if (sibling) {
                linkedWindows.indexOf(sibling) === -1 && linkedWindows.push(sibling);
            }
            return this;
        }

        unlink(s: string | Window) {
            if (!this.isActive) { return this; }

            let sibling;

            if (typeof s === "string") {
                sibling = sbFindIframeContentWindow(s);
            }

            //For some reason in IE postMessage is object
            if (typeof s === "object" && (typeof s["postMessage"] === "function" || typeof s["postMessage"] === "object")) {
                sibling = s;
            }

            if (sibling) {
                sbRemoveFromList(linkedWindows, sibling);
            }
            return this;
        }

        private receiveMessages(e: MessageEvent) {
            let m;
            try { m = JSON.parse(e.data); }
            catch (err) {
                m = undefined;
            }
            m && this.routeMessages(m);
            return this;
        }

        private routeMessages(m) {
            if (m) {
                Object.keys(m).forEach(x => {
                    if (x.match(internalPrefix)) {
                        try { this[x.replace(internalPrefix, "")](m[x]) }
                        catch (err) { console.error(err); }
                    } else if (x.match(sbPrefix)) {
                        if (Array.isArray(this.topics[x])) {
                            this.topics[x].forEach(y => {
                                if (typeof y === "function") {
                                    setTimeout(() => {
                                        try { y(m[x]) }
                                        catch (err) { console.error(err) }
                                    })
                                }
                            });
                        }
                        cacheMaintainer(x, m[x]);
                    }
                });
            }
            return this;
        }

        subscribe(t: string, c: Function) {
            if (typeof this.topics[t] === "undefined") {
                this.topics[t] = [];
            }
            this.topics[t].indexOf(c) === -1 && this.topics[t].push(c);
            if (typeof messagesCache[t] !== "undefined") {
                c(messagesCache[t]);
            }
        }

        unsubscribe(t: string, c: Function) {
            if (Array.isArray(this.topics[t])) {
                sbRemoveFromList(this.topics[t], c);
            }
        }

        post(m: SBMsgBusMessage) {
            let s;
            try { s = JSON.stringify(m); }
            catch (err) {
                s = "";
                console.error(`Tried to send malformed message: ${m}, err > ${err}`);

            }
            linkedWindows.forEach(x => {
                if (typeof x !== "undefined" && (typeof x.postMessage === "function" || typeof x["postMessage"] === "object")) {
                    try { x.postMessage(s, "*") }
                    catch (err) { console.error(err) }
                }
            });
            return this;
        }
    }

    window["sbMsgBus"] = window["sbMsgBus"] || new SBMsgBus();
}());

export const sbMsgBus: SBMsgBus = window["sbMsgBus"];
